import React from "react";
import { useSelector } from "react-redux";
import { FluentResource } from "@fluent/bundle";
import { LocalizationProvider, Localized } from "@fluent/react";

import useError from "@kikoff/hooks/src/useError";
import { ErrorProvider } from "@kikoff/hooks/src/useErrorConsumer";

import PaymentMethod from "@component/payment/base";
import { newReactLocalization } from "@util/l10n";

import styles from "./styles.module.scss";

const RESOURCES = {
  en: new FluentResource(`streamlined-payment-method-title = Payment method
lending-streamlined-payment-method-title = Set up repayment
lending-streamlined-payment-method-subtitle = Make payments on your tradeline to start building payment history
`),
  es: new FluentResource(`streamlined-payment-method-title = Método de pago
lending-streamlined-payment-method-title = Set up repayment
lending-streamlined-payment-method-subtitle = Make payments on your tradeline to start building payment history
`),
};

function StreamlinedPaymentMethod({
  setPaymentMethodToken,
  setValidCardEntry,
}) {
  const paymentMethodError = useError();
  const emphasizeLending = useSelector((state) => state.page.emphasizeLending);

  const l10n = newReactLocalization(RESOURCES);

  return (
    <div className={styles["streamlined-payment-method"]}>
      <LocalizationProvider l10n={l10n}>
        {emphasizeLending ? (
          <div className={styles["payment-method-title"]}>
            <header className="text:large+">
              <Localized id="lending-streamlined-payment-method-title" />
            </header>
            <div className="text:small color:moderate">
              <Localized id="lending-streamlined-payment-method-subtitle" />
            </div>
          </div>
        ) : (
          <div className={`${styles["payment-method-title"]} text:large+`}>
            <Localized id="streamlined-payment-method-title">
              Payment Method
            </Localized>
          </div>
        )}
        <ErrorProvider error={paymentMethodError}>
          <PaymentMethod
            onPaymentMethodTokenChange={setPaymentMethodToken}
            onValidChange={setValidCardEntry}
          />
        </ErrorProvider>
      </LocalizationProvider>
    </div>
  );
}

export default StreamlinedPaymentMethod;
